// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	if (wixWindow.multilingual.currentLanguage === 'en') {
		$w('#horizontalMenu1').collapse();
		$w('#horizontalMenu2').expand();
	} else {
		$w('#horizontalMenu2').collapse();
		$w('#horizontalMenu1').expand();
	}
});